import {
  useController,
  type Control,
  type FieldValues,
  type FieldPath,
  type UseControllerProps,
} from 'react-hook-form'
import { Autocomplete, type AutocompleteProps } from '@design-systems/canvas-ui'

type Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName
  control: Control<TFieldValues>
  rules?: UseControllerProps<TFieldValues, TName>['rules']
} & Omit<AutocompleteProps, 'value' | 'name'>

const ControlledAutocomplete = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  rules,
  ...autoCompleteProps
}: Props<TFieldValues, TName>) => {
  const { field } = useController({
    control,
    name,
    rules,
  })

  return (
    <Autocomplete
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value}
      name={field.name}
      {...autoCompleteProps}
    />
  )
}

export default ControlledAutocomplete
